import { inject, Pipe, PipeTransform } from '@angular/core';
import { DurationUnitsService } from '@lx/shared/utils';
import { DurationUnit } from '@lx/shared/data-access/types';

/**
 * Pipe to provide translatable unit labels.
 * If a quantity is provided, it will take from there the singular or plural form of the unit label.
 * If no quantity is provided, it will return the singular form of the unit label.
 *
 * @example
 * {{ DurationUnit.HOURS | klgUnitLabel }} // "hour"
 * {{ DurationUnit.HOURS | klgUnitLabel : 1 }} // "hour"
 * {{ DurationUnit.HOURS | klgUnitLabel : 3 }} // "hours"
 * {{ DurationUnit.WEEKS | klgUnitLabel }} // "week"
 * {{ DurationUnit.WEEKS | klgUnitLabel | 1 }} // "week"
 * {{ DurationUnit.WEEKS | klgUnitLabel | 10 }} // "weeks"
 */
@Pipe({
  name: 'lxUnitLabel',
  standalone: true,
})
export class UnitLabelPipe implements PipeTransform {
  private readonly durationUnitsService = inject(DurationUnitsService);

  transform(unit: DurationUnit, quantity?: number): string {
    return this.durationUnitsService.getDurationUnit(unit, quantity);
  }
}
